import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReportService } from 'src/app/services/report.service';
import { IsValidPAN } from './../../validation';

@Component({
  selector: 'app-pan-search',
  templateUrl: './pan-search.component.html',
  styleUrls: ['./pan-search.component.scss']
})
export class PanSearchComponent implements OnInit {

  PANForm: FormGroup;
  PANNo: string
  submitPAN: boolean = false
  ClientId: string = ''
  UserName: string = ''
  ClientName: string = ''
  showNotPanOnly:boolean=true
  IsPANValid:boolean=true
  @Output() PANSearchData: EventEmitter<any> = new EventEmitter();
  @Output() ClientIDbyPan: EventEmitter<any> = new EventEmitter();
  constructor(private fb: FormBuilder, private reportservice: ReportService) {
    this.PANForm = this.fb.group({
      PANNO: ['', [Validators.required]],
      UserID: ['', [Validators.required]],
      UserType: ['', [Validators.required]]
    })
  }
  ngOnInit(): void {
    // throw new Error('Method not implemented.');
    this.PANForm.controls["UserType"].setValue("broker")
    let data = window.location.pathname;
    data = data.replace("/app", "");
    if(data == "/fd/fd-orderbook" || data == "/fd/bajajfd-orderbook" || data=="/fd/shriram-fd-orderbook"){
      this.showNotPanOnly=false
    }
  }
  onPANChange() {
    let panno = this.getform["PANNO"].value.toUpperCase()
    var reg = new RegExp(IsValidPAN);
      this.IsPANValid = reg.test(panno);
    if (panno.length >= 10) {
      this.reportservice.PANSearchClient({ PANNO: panno }).subscribe((res) => {
        if (res) {
          if (res.ArrayOfResponse) {
            if (res.ArrayOfResponse.length > 0) {
              this.ClientName = res.ArrayOfResponse[0].ClientName
              this.ClientId = res.ArrayOfResponse[0].ClientID
              if(!this.showNotPanOnly){
                this.ClientIDbyPan.emit({ClientName:this.ClientName,ClientID:this.ClientId})
              }
            }
          }
        }
      })
    }
    else{
      this.ClientName = ""
      this.ClientId = ""
      if(!this.showNotPanOnly){
        this.ClientIDbyPan.emit({ClientName:this.ClientName,ClientID:this.ClientId})
      }
    }
  }
  onSubmit() {
    if (this.PANForm.valid && this.IsPANValid) {
      this.ClientId = ''
      let returnjson = {
        ClientID: "",
        Flag: "",
        UserID: "",
        UserType: "",
        PANNO: ""
      }
      this.submitPAN = false
      let panno = this.getform["PANNO"].value.toUpperCase()
      let UserID = this.getform["UserID"].value.toUpperCase()
      let UserType = this.getform["UserType"].value
      returnjson.PANNO = panno
      //this.PANSearchData.emit(panno)
      this.reportservice.PANSearchClient({ PANNO: panno }).subscribe((res) => {
        if (res) {
          if (res.ArrayOfResponse) {
            if (res.ArrayOfResponse.length > 0) {
              this.ClientId = res.ArrayOfResponse[0].ClientID
              returnjson.ClientID = this.ClientId
              let reqjson = {
                Code: UserID,
                flag: UserType
              }
              this.reportservice.SubbrokerEmpdetails(reqjson).subscribe((res) => {
                if (res) {
                  if (res.ArrayOfResponse) {
                    if (res.ArrayOfResponse.length > 0) {
                      if (UserType == "broker") {
                        this.UserName = res.ArrayOfResponse[0].EmpId == "400" ? "" : res.ArrayOfResponse[0].subbrokername
                        returnjson.UserType = "2"
                        returnjson.UserID = res.ArrayOfResponse[0].SubBrokerId
                        console.warn(returnjson)
                        this.PANSearchData.emit(returnjson)

                      }
                      else if (UserType == "emp") {
                        this.UserName = res.ArrayOfResponse[0].EmpId == "400" ? "" : res.ArrayOfResponse[0].empname
                        returnjson.UserType = "1"
                        returnjson.UserID = res.ArrayOfResponse[0].EmpId
                        console.warn(returnjson)
                        this.PANSearchData.emit(returnjson)
                      }
                    }
                    else {
                      if (UserType == "broker") {
                        this.UserName = ""
                        returnjson.UserType = "2"
                        returnjson.UserID = ""
                        console.warn(returnjson)
                        this.PANSearchData.emit(returnjson)

                      }
                      else if (UserType == "emp") {
                        this.UserName = ""
                        returnjson.UserType = "1"
                        returnjson.UserID = ""
                        console.warn(returnjson)
                        this.PANSearchData.emit(returnjson)
                      }
                    }
                  }
                }
              })
            }
          }
        }
      })
    }
    else {
      this.submitPAN = true
    }
  }
  get getform() {
    return this.PANForm.controls;
  }
}
